import { render, staticRenderFns } from "./serverTransfer.vue?vue&type=template&id=47333e34"
import script from "./serverTransfer.vue?vue&type=script&lang=js"
export * from "./serverTransfer.vue?vue&type=script&lang=js"
import style0 from "./serverTransfer.vue?vue&type=style&index=0&id=47333e34&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports